/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/footer/footer.js":
/*!*********************************!*\
  !*** ./src/js/footer/footer.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   \"default\": () => (/* binding */ Footer)\n/* harmony export */ });\n/* harmony import */ var _utils_validation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/validation */ \"./src/js/utils/validation.js\");\n\nclass Footer extends HTMLElement {\n  constructor() {\n    super();\n    this.newsletterForm = this.querySelector('form');\n    this.newsletterForm.addEventListener('submit', event => this.handleFormSubmit(event));\n    this.infoElement = this.querySelector('[data-info-message]');\n  }\n  handleFormSubmit(event) {\n    event.preventDefault();\n    const action = event.target.action;\n    const inputsElements = this.querySelectorAll('input');\n    const emailElement = this.querySelector('[type=\"email\"]');\n    const wrap = this.querySelector('.t7c-footer__newsletter-input-wrapper');\n    if ((0,_utils_validation__WEBPACK_IMPORTED_MODULE_0__.validateEmail)(emailElement.value)) {\n      emailElement.classList.remove('invalid');\n      wrap.classList.add('loading');\n      fetch(action, {\n        method: 'POST',\n        body: (0,_utils_validation__WEBPACK_IMPORTED_MODULE_0__.getUrlString)((0,_utils_validation__WEBPACK_IMPORTED_MODULE_0__.formToJSON)(inputsElements)),\n        headers: {\n          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'\n        }\n      }).then(result => {\n        this.infoElement.innerHTML = this.infoElement.dataset.successMessage;\n        wrap.classList.remove('loading');\n        emailElement.value = '';\n      });\n    } else {\n      emailElement.classList.add('invalid');\n    }\n  }\n}\n\n//# sourceURL=webpack://my-webpack-project/./src/js/footer/footer.js?");

/***/ }),

/***/ "./src/js/footer/index.js":
/*!********************************!*\
  !*** ./src/js/footer/index.js ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./footer */ \"./src/js/footer/footer.js\");\n\nif (!customElements.get('t7c-footer')) {\n  customElements.define('t7c-footer', _footer__WEBPACK_IMPORTED_MODULE_0__[\"default\"]);\n}\n\n//# sourceURL=webpack://my-webpack-project/./src/js/footer/index.js?");

/***/ }),

/***/ "./src/js/utils/validation.js":
/*!************************************!*\
  !*** ./src/js/utils/validation.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   formToJSON: () => (/* binding */ formToJSON),\n/* harmony export */   getUrlString: () => (/* binding */ getUrlString),\n/* harmony export */   validateEmail: () => (/* binding */ validateEmail)\n/* harmony export */ });\nconst validateEmail = email => {\n  return String(email).toLowerCase().match(/^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|.(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/);\n};\nconst formToJSON = elements => {\n  return [].reduce.call(elements, function (data, element) {\n    data[element.name] = element.value;\n    return data;\n  }, {});\n};\nconst getUrlString = data => {\n  return Object.entries(data).map(function (event) {\n    return event.join('=');\n  }).join('&');\n};\n\n//# sourceURL=webpack://my-webpack-project/./src/js/utils/validation.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/js/footer/index.js");
/******/ 	
/******/ })()
;